import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import comparisonStrings from 'scoreboard/scorecards/edit/comparison-strings'
import calendars from 'scoreboard/components/calendars'

/**
 * Validates a user-supplied calendar name.
 * Prevents adding a calendar with the same name as an existing calendar
 */
function calendarNameValidator(val) {
	if (_.isEmpty(val)) {
		return
	}

	let valComparisonStr = comparisonStrings.get(val, true, true)

	// get comparison strings for existing calendars
	let existingCalendarLabelComparisons = _.map(calendars.calendars, (cal) =>
		comparisonStrings.get(cal.label, true, true))

	if (_.includes(existingCalendarLabelComparisons, valComparisonStr)) {
		return i18n.get('admin.calendar.name.notSameAsExisting')
	}
}


export default calendarNameValidator
calendarNameValidator.__filename__ = 'admin/calendars/calendar-name-validator.js'
